export const CURRENT_YEAR = new Date().getFullYear().toString();
export const ISODateToString = (d) => new Date(d).toISOString().replace('T', ' ').substr(0, 19);